import { render, staticRenderFns } from "./ProjectTaskTemplateDetailNew.vue?vue&type=template&id=28a48b89&"
import script from "./ProjectTaskTemplateDetailNew.vue?vue&type=script&lang=js&"
export * from "./ProjectTaskTemplateDetailNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports